import { useEffect, useState } from "react";
import { Table, Button, Modal, message, Card, Input, Alert, Image } from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  BarsOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import axios from "axios";
import NewsForm from "./newsForm";
import dayjs from "dayjs";
import CommonPagination from "../../components/common/pagination";

const News = () => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [openDetail, setOpenDetail] = useState();
  const [detailData, setDetailData] = useState();
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [total, setTotal] = useState(0);
  const [successMsg, setSuccessMsg] = useState(null);

  const fieldLabels = {
    title_id: "Title ID",
    title_en: "Title EN",
    description_id: "Description ID",
    description_en: "Description EN",
    image: "Image",
    published_date: "Published Date",
    created_at: "Created At",
    updated_at: "Updated At",
  };

  const detailOrder = [
    "title_id",
    "title_en",
    "description_id",
    "description_en",
    "image",
    "published_date",
    "created_at",
    "updated_at",
  ];

  const fetchNews = async (pageNumber = 1) => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${BASE_URL}/api/news?page=${pageNumber}&limit=${limit}&search=${searchText}`,
      );

      console.log("FetchNews response:", res.data);

      setNews(res.data.data || []);
      setTotal(res.data.total || 0);
    } catch (error) {
      console.error("FetchNews error:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchNews(page);
  }, [page, searchText]);

  const handleSubmit = async (formData) => {
    try {
      if (editData) {
        await axios.put(`${BASE_URL}/api/news/${editData.news_id}`, formData);
        setSuccessMsg("News updated");
        setTimeout(() => setSuccessMsg(null), 3000);
      } else {
        await axios.post(`${BASE_URL}/api/news`, formData);
        setSuccessMsg("Review Added");
        setTimeout(() => setSuccessMsg(null), 3000);
      }
      setOpen(false);
      setEditData(null);
      fetchNews(1);
    } catch (err) {
      message.error("Failed to submit news");
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${BASE_URL}/api/news/${id}`);
      setSuccessMsg("News deleted");
      setTimeout(() => setSuccessMsg(null), 3000);

      fetchNews(page);
    } catch (err) {
      message.error("Gagal menghapus News");
    }
  };

  const columns = [
    {
      title: "No",
      render: (_, __, index) => (page - 1) * limit + index + 1,
    },
    { title: "Title ID", dataIndex: "title_id" },
    { title: "Title EN", dataIndex: "title_en" },
    {
      title: "Published Date",
      dataIndex: "published_date",
      render: (value) => (value ? dayjs(value).format("DD-MM-YYYY") : "-"),
    },
    {
      title: "Image",
      dataIndex: "image",
      render: (image) => {
        return image ? (
          <img
            src={`${BASE_URL}${image}`}
            alt="news"
            width={60}
            style={{ objectFit: "cover", borderRadius: 4 }}
          />
        ) : (
          "No Image"
        );
      },
    },
    {
      title: "Actions",
      render: (_, record) => (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          <Button
            style={{ borderColor: "#ec4899", color: "#ec4899", marginRight: 8 }}
            icon={<BarsOutlined />}
            type="link"
            onClick={() => {
              setDetailData({ ...record });
              setOpenDetail(true);
            }}
          />

          <Button
            style={{
              backgroundColor: "#ec4899",
              borderColor: "#ec4899",
              color: "#fff",
              marginRight: 8,
            }}
            icon={<EditOutlined />}
            type="link"
            onClick={() => {
              setEditData({
                ...record,
                image: [
                  {
                    uid: "-1",
                    name: "image.jpg",
                    status: "done",
                    url: `${BASE_URL}${record.image}`,
                  },
                ],
              });
              setOpen(true);
            }}
          />
          <Button
            style={{
              backgroundColor: "#374151",
              borderColor: "#374151",
              color: "#fff",
            }}
            icon={<DeleteOutlined />}
            type="link"
            onClick={() => {
              Modal.confirm({
                title: "Are you sure you want to delete this news?",
                centered: true,
                okText: "Yes",
                okType: "danger",
                cancelText: "No",
                onOk: () => handleDelete(record.news_id),
              });
            }}
          />
        </div>
      ),
    },
  ];

  return (
    <Card title="News">
      {successMsg && (
        <Alert
          message={successMsg}
          type="success"
          showIcon
          style={{
            marginBottom: 16,
            borderRadius: 8,
            backgroundColor: "#f6ffed",
            color: "#389e0d",
          }}
        />
      )}
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Input.Search
          placeholder="Search News..."
          allowClear
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          style={{ width: 300 }}
        />
        <Button
          style={{
            backgroundColor: "#ec4899",
            borderColor: "#ec4899",
            color: "#fff",
          }}
          onClick={() => {
            setEditData(null);
            setOpen(true);
          }}
        >
          + Add News
        </Button>
      </div>

      <Table
        columns={columns}
        dataSource={news}
        rowKey="news_id"
        loading={loading}
        pagination={false}
        style={{ marginTop: 20 }}
      />

      <CommonPagination
        current={page}
        pageSize={limit}
        total={total}
        onChange={(newPage) => setPage(newPage)}
      />

      <Modal
        open={open}
        onCancel={() => {
          setOpen(false);
          setEditData(null);
        }}
        footer={null}
        destroyOnClose
      >
        <NewsForm
          initialValues={editData}
          onSuccess={handleSubmit}
          editMode={!!editData}
        />
      </Modal>

      <Modal
        title="Awards Detail"
        open={openDetail}
        onCancel={() => setOpenDetail(false)}
        footer={[
          <Button
            key="close"
            style={{
              backgroundColor: "#ec4899",
              borderColor: "#ec4899",
              color: "#fff",
              marginRight: 8,
            }}
            onClick={() => setOpenDetail(false)}
          >
            Close
          </Button>,
        ]}
      >
        {detailData && (
          <Table
            dataSource={detailOrder.map((key) => {
              let value = detailData[key];
              if (key === "image") {
                if (value) {
                  const src = `${BASE_URL}${value}`;
                  value = (
                    <Image
                      src={src}
                      width={100}
                      style={{ borderRadius: 4 }}
                      preview={{
                        mask: (
                          <EyeOutlined
                            style={{ color: "white", fontSize: 18 }}
                          />
                        ),
                      }}
                    />
                  );
                } else {
                  value = "-";
                }
              }

              if ((key === "created_at" || key === "updated_at") && value) {
                value = dayjs(value).format("YYYY-MM-DD HH:mm:ss");
              }

              if (key === "published_date" && value) {
                value = dayjs(value).format("YYYY-MM-DD");
              }

              return {
                key,
                field: fieldLabels[key] || key,
                value,
              };
            })}
            columns={[
              {
                title: "Field",
                dataIndex: "field",
                key: "field",
                width: "30%",
                render: (text) => <strong>{text}</strong>,
              },
              { title: "Value", dataIndex: "value", key: "value" },
            ]}
            pagination={false}
            bordered
          />
        )}
      </Modal>
    </Card>
  );
};

export default News;
